var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-visual"
  }, [_c('swiper', {
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_vm._l(_vm.slides, function (slide, index) {
    return [_c('swiper-slide', {
      key: index
    }, [_c('v-card', {
      staticClass: "main-visual__inner",
      attrs: {
        "flat": "",
        "tile": "",
        "img": slide.image
      }
    }, [_c('div', {
      staticClass: "main-visual__text"
    }, [slide.title ? [_c('tit-wrap', {
      staticClass: "tit-wrap--sm"
    }, [_c('tit', {
      staticClass: "font-size-lg-32 font-weight-regular white--text"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(slide.title)
      }
    }), _c('div', [_c('strong', [_vm._v("더포디엄830 청년안심 주택")])])])], 1)] : _vm._e(), slide.text ? [_c('txt', {
      staticClass: "txt--lg line-height-17 white--text"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(slide.text)
      }
    })])] : _vm._e()], 2)])], 1)];
  })], 2), _c('swiper-pagination-quarternary'), _c('main-visual-requirement')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }